import { createSelector } from '@reduxjs/toolkit'

export const amountToRedeemSelector = createSelector(
  (state: AppState) => state.redeem.amountToRedeem,
  (value) => value
)

export const burnFormValuesSelector = createSelector(
  (state: AppState) => state.redeem.burnFormValues,
  (value) => value
)

export const currentStepSelector = createSelector(
  (state: AppState) => state.redeem.currentStep,
  (value) => value
)

export const redeemErrorSelector = createSelector(
  (state: AppState) => state.redeem.error,
  (value) => value
)

export const txHashSelector = createSelector(
  (state: AppState) => state.redeem.txHash,
  (value) => value
)
